import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {Button, Grid, TextField} from '@mui/material'
import {useMemo, useState} from "react";
import {IntInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";
import {isCnpj, isCpf} from "@shared/ValidationHelp.ts";
import {CpfCnpjInput} from "@shared/custom/CpfCnpjInput.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";

interface CreateEmpresaComponentProps {
    onCreate?: (r: IEmpresa) => void;
}

export function CreateEmpresaComponent(props: CreateEmpresaComponentProps) {
    const {createEmpresa} = useEmpresa()
    const {createAlertFromResponse} = useAlert()

    const [data, setData] = useState<Pick<IEmpresa, 'nome' | 'cnpj' | 'nroFilial'>>({
        cnpj: '',
        nome: '',
        nroFilial: 0,
    })

    const filialOk = useMemo(() => {
        return (data.nroFilial > 0)
    }, [data.nroFilial]);

    const cnpjOk = useMemo(() => {
        return (isCnpj(data.cnpj) || isCpf(data.cnpj))
    }, [data.cnpj])

    const nomeOk = useMemo(() => {
        return data.nome.length > 3
    }, [data.nome])

    const handleCreate = () => {
        if (!(filialOk && cnpjOk && nomeOk)) return;

        createEmpresa(data).then(x => {
            if (x.items) {
                if (props.onCreate != null) props.onCreate(x.items);
            }
            createAlertFromResponse(x)
        })
    }


    return (<Grid container size={12} component={'form'}
                  onSubmit={handleCreate}>
        <Grid size={12}>
            <TextField value={data.nome}
                       error={!nomeOk}
                       onChange={(e) => {
                           setData(prev => ({...prev, nome: e.target.value}))
                       }} label={'Nome'}/>
        </Grid>
        <Grid size={{xs: 12, sm: 8}}>
            <CpfCnpjInput slotProps={{
                TextField: {
                    variant: 'filled',
                    error: !cnpjOk,
                }
            }}
                          value={data.cnpj}
                          onChange={e => {
                              setData(prev => ({...prev, cnpj: e}))
                          }}/>
        </Grid>
        <Grid size={{xs: 12, sm: 4}}>
            <IntInputEntry value={data.nroFilial}
                           textFieldProps={{
                               error: !filialOk
                           }} onChange={e => {
                setData(prev => ({...prev, nroFilial: e}))
            }} label={'Nro filial'}/>
        </Grid>
        <Grid size={12}>
            <Button onClick={handleCreate} disabled={!(cnpjOk && filialOk)} fullWidth variant={'contained'}>
                Criar
            </Button>
        </Grid>
    </Grid>)
}